import * as S from './styles'
import { useResults } from './useResults'
import { Image, Text } from '@/components'
import { useIsVisibleElement } from '@/hooks/useIsVisibleElement'
import { Results } from '@/service/api/casePage'

export type ResultsContainerProps = {
  data: Results
  color: string
}
export const ResultsContainer: React.FC<ResultsContainerProps> = ({
  data,
  color,
}) => {
  const { fontSizes } = useResults()
  const { element, elementVisible } = useIsVisibleElement()
  return (
    <S.ResultsContainer color={color} elementVisible={elementVisible}>
      <div className="container" ref={element}>
        <Text size={fontSizes.title} color="darkgray" className="title">
          {data.title}
          <span className="bar" />
        </Text>
        <div className="descriptions">
          <div className="description">
            <Text color="darkgray" size={fontSizes.description}>
              {data.description1}
            </Text>
          </div>

          {data.description2 && (
            <div className="description">
              <Text color="darkgray" size={fontSizes.description}>
                {data.description2}
              </Text>
            </div>
          )}
        </div>
      </div>
      <Image src={data.banner.url} alt="banner" className="banner" />
      <Image
        src={data.bannerMobile.url}
        alt="banner"
        className="banner-mobile"
      />
    </S.ResultsContainer>
  )
}
